import React from "react";
import { useFormat } from "@sinch/core/hooks/format";
import { isNotNilOrEmpty } from "ramda-adjunct";
import { parseAddress } from "@sinch/utils/geolocation/address";
import { IconListRow } from "@sinch/components/IconListRow/IconListRow";
import { MdsBlockFill, MdsCheckCircleFillXs, MdsLocationOnXs, MdsMailXs, MdsPhoneIphoneXs } from "@sinch/icons";
import { Stack, Tooltip, Typography } from "@mui/material";
import { ContactLink } from "@sinch/components/application/ContactLink/ContactLink";
import { CopyToClipboard } from "@sinch/components/CopyToClipboard/CopyToClipboard";
import { StaffHeaderFragment } from "@sinch/components/application/Staff/StaffHeader/fragments.types";
import { MdsIcon } from "@sinch/components";
import { useTranslation } from "react-i18next";

export const StaffContactInfo: React.FC<{ staff: StaffHeaderFragment }> = ({ staff }) => {
  const { t } = useTranslation();
  const { phone, address } = useFormat();
  const { workerinfo, email, phone: phoneNumber } = staff;

  return (
    <>
      {workerinfo && isNotNilOrEmpty(parseAddress(workerinfo)) && (
        <IconListRow icon={MdsLocationOnXs} iconAlign="firstLine" iconSize="xs">
          <Typography>{address.full(workerinfo)}</Typography>
        </IconListRow>
      )}
      {email && (
        <CopyToClipboard alwaysVisible value={email}>
          <ContactLink href={`mailto:${email}`} icon={MdsMailXs} label={email} />
        </CopyToClipboard>
      )}
      {phoneNumber && (
        <CopyToClipboard alwaysVisible value={phone.national(phoneNumber)}>
          <ContactLink
            href={phone.uri(phoneNumber)}
            icon={MdsPhoneIphoneXs}
            label={
              <Stack alignItems="center" direction="row" spacing={0.5}>
                <span>{phone.national(phoneNumber)}</span>
                {workerinfo?.phoneVerified === true && (
                  <Tooltip title={t("verified")}>
                    <MdsIcon color="success" fontSize="xs" icon={MdsCheckCircleFillXs} />
                  </Tooltip>
                )}
                {workerinfo?.phoneVerified === false && (
                  <Tooltip title={t("nonVerified")}>
                    <MdsIcon color="error" fontSize="xs" icon={MdsBlockFill} />
                  </Tooltip>
                )}
              </Stack>
            }
          />
        </CopyToClipboard>
      )}
    </>
  );
};
